<template>
<div class="page-title">
    <div class="title">
        <h3>Bookings</h3>
    </div>
    <div class="filters">
        <el-form
            label-position="top"
        >
            <el-row>
                <el-col :span="2" >
                    <el-form-item label="Types">
                        <el-select v-model="form.service"  placeholder="Select" size="small" clearable>
                            <el-option
                                v-for="item in data.services"
                                :key="item"
                                :label="item"
                                :value="item"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-form-item class="ml-2" label="Stage">
                        <el-select v-model="form.stage"  placeholder="Select" size="small" clearable>
                            <el-option
                                v-for="item in stages"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item class="ml-2" label="Date Type">
                        <el-select v-model="form.type"  placeholder="Select" size="small">
                            <el-option
                                v-for="item in types"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item class="ml-2" label="Date Range" size="small">
                        <el-date-picker
                            v-model="form.daterange"
                            type="daterange"
                            unlink-panels
                            range-separator="-"
                            start-placeholder="Start date"
                            end-placeholder="End date"
                            :shortcuts="dateshortcuts"
                            format="DD/MMM/YYYY"
                            value-format="YYYY-MM-DD"


                        />
                    </el-form-item>
                </el-col>
                <el-col :span="4" v-if="underusers.length>0">
                    <el-form-item class="ml-2" label="Agent" size="small">
                        <el-select v-model="form.user" value-key="id" placeholder="Select Agent" clearable>
                            <el-option
                                v-for="item in underusers"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"


                            >

                                    <el-avatar class="mr-2 " :size="20" :src="'https://crm.pickotrip.com/images/agents/'+item.name+'.jpg'" />
                                    {{ item.name }}



                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>


                <el-col :span="3">
                    <el-form-item class="ml-2" label=" .">
                    <el-button @click="form.page=1;getlist()"  type="primary" size="small"  round >Apply Filters</el-button>
                    </el-form-item>
                </el-col>
            </el-row>



        </el-form>



    </div>
</div>

    <div v-if="!loading">
        <el-card class="box-card mt-2 booking-list-box" v-for="booking in bookings" :key="booking.id" @click="openbooking(booking.viewlink)">
            <template #header>
                <el-row >
                    <el-col :span="12">
                        <el-tag class="mr-2 bdark" effect="dark" >CDM{{booking.id}}</el-tag>
                        <el-tag class="mr-2" style="" >
                            {{booking.booking_date}}</el-tag>
                        <el-tag class="mr-2" style="" >
                            {{booking.type}}</el-tag>
                        <el-tag class="mr-2" style="" v-if="booking.unique_id" >
                            {{booking.unique_id}}</el-tag>
                        <el-tag class="mr-2" v-if="booking.enq_source!=''" >
                            {{booking.enq_source}}</el-tag>


                    </el-col>
                    <el-col :span="12" >
                        <el-row justify="end">
                            <el-tag class="mr-2" effect="dark" type="success" v-if="booking.customer_handover==1" >Handovered to Customer</el-tag>
                            <el-tag class="mr-2" effect="dark" type="danger"  >{{booking.currentdepartment}}</el-tag>
                            <el-tag class="mr-2" effect="dark" :type="booking.stage=='Booked'? 'success' : booking.stage=='Postponed'? 'warning' : 'danger'" >{{booking.stage}}</el-tag>
                            <el-tag class="mr-2" style="" >
                                <el-avatar class="mr-2" :size="20" :src="'https://crm.pickotrip.com/images/agents/'+booking.assignedto+'.jpg'" />
                                {{booking.assignedto}}</el-tag>

                        </el-row>
                    </el-col>

                </el-row>


            </template>
            <div  class="booking-contents">
                <div>
                    <p class="lbl">Name</p>
                    <p class="vlv">{{booking.name}}</p>
                </div>
                <el-divider direction="vertical" />
                <div>
                    <p class="lbl">Mobile</p>
                    <p class="vlv">{{booking.mobile}}</p>
                </div>
                <el-divider direction="vertical" />
                <div>
                    <p class="lbl">Destinations</p>
                    <p class="vlv">{{booking.destinations}}</p>
                </div>
                <el-divider direction="vertical" />
                <div>
                    <p class="lbl">Departure Date</p>
                    <p class="vlv">{{booking.departuredate}}</p>
                </div>
                <el-divider direction="vertical" />
                <div>
                    <p class="lbl">Quote Price</p>
                    <p class="vlv">{{booking.quote_price.toLocaleString()}}</p>
                </div>
                <el-divider direction="vertical" />
                <div>
                    <p class="lbl">Profit</p>
                    <p class="vlv">{{booking.profit.toLocaleString()}}</p>
                </div>
                <el-divider direction="vertical" />
                <div>
                    <p class="lbl">Customer Payments</p>
                    <p class="vlv "><span class="text-danger">Pending / {{booking.customerpayment.pending.toLocaleString()}}</span><span class="text-success ml-2">Received / {{booking.customerpayment.received.toLocaleString()}}</span></p>
                </div>
                <el-divider direction="vertical" />
                <div>
                    <p class="lbl">Vendor Payments</p>
                    <p class="vlv "><span class="text-danger">Pending / {{booking.vendorpayment.pending.toLocaleString()}}</span><span class="text-success ml-2">Paid / {{booking.vendorpayment.paid.toLocaleString()}}</span></p>
                </div>
            </div>
        </el-card>
        <el-card class="box-card mt-2" v-if="total>0">
            <el-row  >
                <el-col justify="right">

                    <el-space  ></el-space>
                    <el-pagination style="width: fit-content;" v-model:current-page="form.page" class="mt-4 mb-4" v-model:page-size="form.size" background layout="total, sizes, prev, pager, next" :page-sizes="[10, 50, 100, 200,300,400,500,1000]" @current-change="pageChange" @size-change="handleSizeChange" :total="total" />
                    <el-space  ></el-space>

                </el-col>
            </el-row>
        </el-card>

    </div>
    <div v-else>
        <el-card class="box-card mt-2 booking-list-box" v-for="i in 7" :key="i">
            <el-skeleton :rows="1" animated />
        </el-card>

    </div>

</template>
<style>

</style>
<script>
import  { ElSpace,ElPagination,ElSelect, ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton  } from 'element-plus'
import 'element-plus/dist/index.css'
import moment from 'moment'
export default {
    name: "BookingList",
    components: { ElSpace,ElPagination,ElSelect,ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton },
    data() {
        return {
            loading: true,
            form:{
                page:1,
                stage:'',
                type:'0',
                daterange:[moment().startOf('month').format('YYYY-MM-DD'),moment().endOf('month').format('YYYY-MM-DD')],
                user:'',
                service:'',
                size:10,
            },
            data:{
                user:null,
                destinations:[],
                services:[]
            },
            total:0,
            stages:[
                {
                    value:'',
                    label:'All'
                },
                {
                    value:'Booked',
                    label:'Booked'
                },
                {
                    value:'Postponed',
                    label:'Postponed'
                },
                {
                    value:'Cancelled',
                    label:'Cancelled'
                }
            ],
            types:[
                {
                    value:'0',
                    label:'Booking Date'
                },
                {
                    value:'1',
                    label:'Departure Date'
                }

            ],
            dateshortcuts : [
                {
                    text: 'This Month',
                    value: () => {

                        return [moment().startOf('month').format('YYYY-MM-DD'),moment().endOf('month').format('YYYY-MM-DD')]
                    },
                },
                {
                    text: 'Last month',
                    value: () => {

                        return [moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')]
                    },
                },
                {
                    text: 'Last 3 months',
                    value: () => {
                        return [moment().subtract(3, 'month').startOf('month').format('YYYY-MM-DD'),moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')]

                    },
                },
                {
                    text: 'Next month',
                    value: () => {

                        return [moment().add(1, 'month').startOf('month').format('YYYY-MM-DD'),moment().add(1, 'month').endOf('month').format('YYYY-MM-DD')]
                    },
                },
                {
                    text: 'Next 3 months',
                    value: () => {
                        return [moment().add(1, 'month').startOf('month').format('YYYY-MM-DD'),moment().add(3, 'month').endOf('month').format('YYYY-MM-DD')]

                    },
                },
                {
                    text: 'Next 10 Days',
                    value: () => {

                        return [moment().add(1, 'day').format('YYYY-MM-DD'),moment().add(10, 'day').format('YYYY-MM-DD')]
                    },
                },
            ],
            bookings:[],
            underusers:[]
        }
    },
    mounted() {
        this.getlist();
    },
    methods: {
        getlist() {
            this.loading=true;
            let currentObj = this;
            axios.post('/bookings/list',this.form).then(function (response) {
                currentObj.bookings=response.data.bookings;
                currentObj.underusers=response.data.underusers;
                currentObj.total=response.data.total;
                currentObj.data=response.data.data;
                currentObj.loading=false;

            })
                .catch(function (error) {
                    currentObj.loading=false;
                });
        },
        pageChange(page){
            this.form.page=page;
            this.getlist();
        },
        handleSizeChange(size){
            this.form.page=1;
            this.form.size=size;
            this.getlist();
        },

        openbooking(link){
            window.open(link, "_blank", "width="+screen.availWidth+",height="+screen.availHeight)

        }
    }
}
</script>

<style scoped>

</style>
